import { render, staticRenderFns } from "./write.vue?vue&type=template&id=4a0d11f8&"
import script from "./write.vue?vue&type=script&lang=js&"
export * from "./write.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports